import React from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import {BackButton} from '../../components/BackButton';
import Img_Icon from '../../assets/images/Group_Icon_digisign.png';
import Layout_1 from '../../assets/images/Layer_1_Detail_digisign1.png';
import Layout_2 from '../../assets/images/Layer_2_Detail_digisign1.png';

const DetailDigisign1 = () => {
  const [animate, setAnimate] = React.useState (false);
  const [animateLayout2, setAnimateLayout2] = React.useState (false);
  const onClickImg = () => {
    setAnimate(false);
    setAnimateLayout2(false);
    // setAnimate (true);
    // setTimeout (() => setAnimateLayout2 (true), 2200); // delay 2.2s
  };
  return (
    <AnimatedPage animationType="fade">
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <BackButton />
        <img
          src={Img_Icon}
          alt=""
          style={{
            width: `calc(977 / 4096 * 100vw)`,
            height: `calc(453 /  2160 * 100vh)`,
            objectFit: 'contain',
            marginTop: `calc(50 / 2160 * 100vh)`,
          }}
        />
        <img
          src={Layout_1}
          onClick={onClickImg}
          alt=""
          style={{
            marginTop: `calc(172 / 2160 * 100vh)`,
            width: `calc(2200 / 4096 * 100vw)`,
            height: `calc(1120 /  2160 * 100vh)`,
            objectFit: 'contain',
            transition: 'transform 2s cubic-bezier(0.7,0,1,1), opacity 0.3s 2s',
            transform: animate ? 'scale(1.2)' : 'scale(1)',
            opacity: animate ? 0 : 1,
            display: animateLayout2 ? 'none' : 'block',
          }}
        />

        <img
          src={Layout_2}
          alt=""
          style={{
            marginTop: `calc(63 / 2160 * 100vh)`,
            width: '100%',
            height: `calc(1480 /  2160 * 100vh)`,
            objectFit: 'contain',
            transition: 'transform 2s cubic-bezier(0.7,0,1,1), opacity 0.3s',
            transform: animateLayout2 ? 'scale(1)' : 'scale(1.2)',
            opacity: animateLayout2 ? 1 : 0,
            visibility: animateLayout2 ? 'visible' : 'hidden',
          }}
        />

      </div>
    </AnimatedPage>
  );
};

export default DetailDigisign1;
